import * as React from 'react';
import {
  Box, Button, Typography, Modal, FormControl,
  Grid, IconButton, InputLabel, MenuItem, Select, TextField,
  useMediaQuery
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import emailjs from '@emailjs/browser';
import { CmpTextField } from '../commonFields/ComTypography';
import './Style.css';
import { fAlertToast } from '../Utility/Utility';


export default function FormModal({ open, handleClose }) {
  const vMediaQuery = useMediaQuery("(max-width:650px)");
  const form = React.useRef();
  const description = ['General Enquiry', 'Request a Demo', 'Get a Quote'];

  let initObj = {
    from_firstname: '',
    from_lastname: '',
    from_email: '',
    from_phNo: '',
    from_jobTitle: '',
    from_enqiury: description[0] || '',
    message: ''
  };

  const [formData, setFormData] = React.useState(initObj);

  let initError = {
    from_firstname: '',
    from_lastname: '',
    from_email: '',
    from_phNo: '',
    from_jobTitle: '',
    from_enqiury: '',
    message: ''
  }
  const [errors, setErrors] = React.useState(initError)

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "from_phNo" && !/^\d*$/.test(value)) {
      return; // Prevent non-numeric characters
    }
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: value.trim() ? '' : prev[name] // Remove error if input is not empty
    }));
  };

  React.useEffect(() => {
    if (open) {
      setTimeout(() => {
        document.getElementById('from_firstname')?.focus();
      }, 400);
    }
  }, [open])

  const validationField = () => {
    let isValid = true;
    let newErrors = {};

    if (formData.from_firstname === '') {
      newErrors.from_firstname = 'First Name is required';
      isValid = false;
    }

    if (formData.from_lastname === '') {
      newErrors.from_lastname = 'Last Name is required';
      isValid = false;
    }

    if (formData.from_email === '') {
      newErrors.from_email = 'Email is required';
      isValid = false;
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.from_email)) {
      newErrors.from_email = 'Enter a valid email';
      isValid = false;
    }

    if (formData.from_phNo === '') {
      newErrors.from_phNo = 'Phone Number is required';
      isValid = false;
    }

    if (formData.from_jobTitle === '') {
      newErrors.from_jobTitle = 'Job Title is required';
      isValid = false;
    }

    if (formData.message === '') {
      newErrors.message = 'Description is required';
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const sendEmail = (e) => {
    e.preventDefault();

    if (!validationField()) return;

    emailjs
      .sendForm('service_tarkyjl', 'template_w65hnq4', form.current, {
        publicKey: 'bDiLdwyQEZINQVP0t',
      })
      .then(
        () => {
          fAlertToast('Email sent successfully!', 'success');
          setFormData(initObj);
          setErrors(initError);
          setTimeout(() => {
            document.getElementById('from_firstname')?.focus();
          }, 400);
        },
        (error) => {
          fAlertToast(`Failed to send email: ${error.text}`, 'error');
        }
      );

    fAlertToast('Email sent successfully!', 'success');
  };


  const handleDropdownChange = (e) => {
    handleChange(e); // Update state

    setTimeout(() => {
      document.getElementById('message').focus();
    }, 400);
  };

  const handleKeyDown = (e, nextFieldId) => {
    if (e.key === "Enter") {
      e.preventDefault(); // Prevent form submission
      const nextField = document.getElementById(nextFieldId);
      if (nextField) {
        nextField.focus(); // Move focus to the next input field
      }
    }
  };

  const handleModalClose = () => {
    handleClose();
    setErrors(initError);
  }

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: vMediaQuery ? '95%' : '70%',
    height: 'auto',
    overFlowY: 'auto',
    bgcolor: 'background.paper',
    boxShadow: 24,
    borderRadius: 3
  };

  return (
    <Modal open={open} onClose={handleModalClose}>
      <Box sx={style}>
        <div className='modal-head'>
          <Typography variant='h6'>Schedule a Call!</Typography>
          <IconButton onClick={handleModalClose}>
            <CloseIcon />
          </IconButton>
        </div>

        <Box p={vMediaQuery ? 2 : 4} className='form'>
          <form ref={form} onSubmit={sendEmail}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <CmpTextField
                  xLabel='First Name'
                  xId={'from_firstname'}
                  xName='from_firstname'
                  xValue={formData.from_firstname}
                  xOnchange={handleChange}
                  xOnKeyDown={(e) => handleKeyDown(e, 'from_lastname')}
                  xError={!!errors.from_firstname}
                  xHelperText={errors.from_firstname}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <CmpTextField
                  xLabel='Last Name'
                  xName='from_lastname'
                  xId={'from_lastname'}
                  xValue={formData.from_lastname}
                  xOnchange={handleChange}
                  xOnKeyDown={(e) => handleKeyDown(e, 'from_email')}
                  xError={!!errors.from_lastname}
                  xHelperText={errors.from_lastname}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <CmpTextField
                  xLabel='Email'
                  xType='email'
                  xId={'from_email'}
                  xName='from_email'
                  xValue={formData.from_email}
                  xOnchange={handleChange}
                  xOnKeyDown={(e) => handleKeyDown(e, 'from_phNo')}
                  xError={!!errors.from_email}
                  xHelperText={errors.from_email}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <CmpTextField
                  xLabel='Phone'
                  xType='number'
                  xName='from_phNo'
                  xId={'from_phNo'}
                  xValue={formData.from_phNo}
                  xOnchange={handleChange}
                  xOnKeyDown={(e) => handleKeyDown(e, 'from_jobTitle')}
                  xError={!!errors.from_phNo}
                  xHelperText={errors.from_phNo}
                  sx={{
                    "& input:focus::-webkit-outer-spin-button, & input:focus::-webkit-inner-spin-button": {
                      WebkitAppearance: "none !important",
                      margin: 0,
                    },
                    "& input:focus[type=number]": {
                      MozAppearance: "textfield",
                      visibility:'hidden !important'
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <CmpTextField
                  xLabel='Job Title'
                  xName='from_jobTitle'
                  xId={'from_jobTitle'}
                  xValue={formData.from_jobTitle}
                  xOnchange={handleChange}
                  xOnKeyDown={(e) => handleKeyDown(e, 'from_enqiury')}
                  xError={!!errors.from_jobTitle}
                  xHelperText={errors.from_jobTitle}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <FormControl fullWidth>
                  <InputLabel>Purpose of Enquiry</InputLabel>
                  <Select
                    type='select'
                    label='Purpose of Enquiry'
                    name='from_enqiury'
                    id={'from_enqiury'}
                    value={formData.from_enqiury}
                    onChange={handleDropdownChange}
                  >
                    {description.map((item, index) => (
                      <MenuItem key={index} value={item}>{item}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <TextField sx={{
                  '& .MuiOutlinedInput-root': {
                    padding: vMediaQuery ? '0px' : "16.5px 14px"
                  }
                }}
                  fullWidth
                  label='Description'
                  type='text'
                  name='message'
                  id='message'
                  placeholder='What Technology or Solution are you interested in?'
                  value={formData.message}
                  onChange={handleChange}
                  error={!!errors.message}
                  helperText={errors.message}
                  InputLabelProps={{ shrink: true }}
                  autoComplete='off'
                  multiline
                  rows={3}
                />
              </Grid>
              <Grid item xs={12} textAlign='center'>
                <Button
                  type="submit"
                  sx={{
                    backgroundColor: "#6a6ab0",
                    color: "white",
                    textTransform: "capitalize",
                    "&:hover": {
                      backgroundColor: "#6a6ab0", // Prevents color change on hover
                    },
                  }}
                >
                  Send Message
                </Button>

              </Grid>
            </Grid>
          </form>
        </Box>
      </Box>
    </Modal>
  );
}
